// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"_12N9Uf0dcTNhJHkHaFySc5","block":"_2Lids_tzTrWKs5XQVxJVGZ","blockName":"_3LGbKAYakV8NvMSEQeo_kS","blockValue":"_23P3o73JgFEFmnOcBo9HhB"};